import {
  GetStateVariablesParams,
  getStateVariables,
} from '@akin-home/state-variables-frontend';
import { UseQueryOptions, useQuery } from 'react-query';

export const useListStateVariables = (
  params: GetStateVariablesParams,
  options?: UseQueryOptions
) => {
  const { username, application_id } = params;

  return useQuery(
    ['state_variables', 'list', username, application_id, params.names],
    () => getStateVariables(params),
    options as any
  );
};
